export default __webpack_public_path__ + "static/media/06-small.c675b90d.jpg";